module.exports = __webpack_public_path__ + "static/media/Error.01c949d8.svg";